export const EMAIL_DELIVERY_HUB_TABLE_SEARCHABLE_COLUMNS = [
  'subject',
  'recipients',
  'clientPartnerNames',
  'clientManagerNames',
  'clientIds',
  'clientGroupNames',
  'attachmentNames',
  'officeNames',
  'clientNames',
  'status',
  'emailType',
  'bcc',
  'cc',
];
